module.exports = __webpack_public_path__ + "static/ozd_accounting_logo-48d8bc138d6a4288d49b4b4c886c916c.jpg";